import LicenseKeys from "@/helpers/Constants/LicenseKeys";

export default Object.freeze({
    QuotationLicenseKey: LicenseKeys.Quotation,
    ContractLicenseKey: LicenseKeys.Contract,

    ids: {
        Draft: 1,
        Quotation: 2,
        Contract: 3,
        ServiceJob: 4
    },

    typeTypes: {
        Quotation: 1,
        ServiceJob: 2,
        Other: 0
    },

    typeTypeIcons: {
        0: 'mdi-receipt-text-clock', //except draft that has a different icon by id
        1: 'mdi-file-delimited',
        2: 'mdi-briefcase'
    },
});